import React, { useState } from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { theme } from "../../../Theme/index";
import USIcon from "../../../Assets/us.png";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { Badge, Typography, useMediaQuery } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useDispatch } from "react-redux";
import { setSelectedFilter } from "../../../Redux/filterSlice/filterSlice";
import { setCurrentChartType } from "../../../Redux/chartSlice/chartSlice";
import { setAllMarketSelected } from "../../../Redux/handleAllMarket/handleAllMarket";

function RightBar() {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorPosition, setAnchorPosition] = useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    const target = event.currentTarget;
    setAnchorEl(target);
    const rect = target.getBoundingClientRect();
    setAnchorPosition({
      top: rect.bottom,
      left: rect.right,
    });
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setAnchorPosition(null);
  };

  const handleLogout = () => {
    handleMenuClose();
    localStorage.removeItem("userId");
    localStorage.removeItem("projectId");
    localStorage.removeItem("page");
    localStorage.removeItem("name");
    localStorage.removeItem("manufacturer");
    dispatch(setSelectedFilter([]));
    dispatch(setCurrentChartType(null));
    dispatch(setAllMarketSelected(false));
    window.location.href = "/login";
  };

  const ICON_SIZE = { xs: 32, sm: 36, md: 40 };

  const RightBox = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: { xs: "310px", sm: "auto" },
    gap: isMobile ? 1 : 2,
    paddingLeft: isMobile ? "4px" : "50px",
    whiteSpace: "nowrap",

  }));
  return (
    <RightBox
      sx={{
        paddingLeft: { xs: "10px", sm: "50px" }
      }}
    >
      {/* <IconButton
        aria-label="Language"
        sx={{
          padding: isMobile ? "10px" : "20px",
          width: ICON_SIZE,
          height: ICON_SIZE,
        }}
      >
        <Avatar src={USIcon} sx={{ width: "30px", height: "30px" }} />
      </IconButton> */}

      <Box sx={{ display: "flex", flexDirection: "row" }}>
        {/* <IconButton
          aria-label="notifications"
          sx={{
            bgcolor: "#FFFAF1",
            width: ICON_SIZE,
            height: ICON_SIZE,
            margin: "auto",
          }}
        >
          <Badge color="accent" variant="dot" invisible={false}>
            <NotificationsNoneOutlinedIcon
              sx={{
                width: ICON_SIZE,
                height: ICON_SIZE,
                color: `${theme.palette.accent.light}`,
              }}
            />
          </Badge>
        </IconButton> */}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            marginLeft: "5px",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={handleMenuOpen}
          aria-controls={open ? "user-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <Avatar
            variant="circle"
            sx={{ width: ICON_SIZE, height: ICON_SIZE, margin: "auto" }}
            src=""
          />
          <Box sx={{ marginLeft: "8px", marginRight: "8px" }}>
            <Typography
              color="primary"
              fontSize={
                isTablet
                  ? 14
                  : 18
              }
              fontWeight={theme.typography.fontWeightMedium}
            >
              {localStorage.getItem("name")}
            </Typography>
            <Typography
              fontSize={isTablet ? 12 : 14}
              fontWeight={theme.typography.fontWeightRegular}
              sx={{ color: "#737791" }}
            >
              Admin
            </Typography>
          </Box>
          <IconButton size="small" sx={{ ml: 0.5 }}>
            <KeyboardArrowDownIcon color="primary" />
          </IconButton>
        </Box>
        <Menu
          id="user-menu"
          anchorReference="anchorPosition"
          anchorPosition={
            anchorPosition
              ? { top: anchorPosition.top, left: anchorPosition.left }
              : undefined
          }
          open={open}
          onClose={handleMenuClose}
          onClick={handleMenuClose}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          slotProps={{
            root: {
              sx: { zIndex: 1500 },
            },
            paper: {
              elevation: 3,
              sx: { minWidth: 160, mt: 1.5, zIndex: 1500 },
            },
            backdrop: {
              sx: { zIndex: 1500 },
            },
          }}
          sx={{ zIndex: 1500 }}
        >
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <LogoutOutlinedIcon fontSize="small" sx={{ color: theme.palette.primary.main }} />
            </ListItemIcon>
            <ListItemText>Log out</ListItemText>
          </MenuItem>
        </Menu>
      </Box>
    </RightBox>
  );
}
export default RightBar;
